// The country and use case each organisation searches in (2026-10-14).
// Neither is a choice in the search panel: a tenant works in one country and
// one use case, both read from its branding (docs/tenant-siting-profiles.md).
//
//   use case  siting_profile.use_case → default_use_case → 'data_center'
//   country   default_country when the tenant offers it → first of countries → 'NO'
//
// The public site sets neither and resolves to data centres in Norway. North
// Ammonia's ammonia profile resolves to 'hydrogen', the enum the ammonia plant
// model runs under, in Norway.

export const TENANT_COUNTRIES = ['NO', 'FI', 'IT'];

// default_use_case has been stored both as the search enum ('data_center')
// and as the Projects mode ('datacenter'); 'ammonia' runs as 'hydrogen'.
const USE_CASE_ALIASES = {
  data_center: 'data_center', datacenter: 'data_center',
  hydrogen: 'hydrogen', ammonia: 'hydrogen',
};

export function tenantUseCase(branding) {
  const b = branding || {};
  const profile = b.siting_profile && typeof b.siting_profile === 'object' ? b.siting_profile : null;
  // A profile without a use case is an ammonia profile (siting_profiles.py).
  const fromProfile = profile ? (profile.use_case || (profile.plant === 'ammonia' ? 'hydrogen' : null)) : null;
  const raw = String(fromProfile || b.default_use_case || '').toLowerCase();
  return USE_CASE_ALIASES[raw] || 'data_center';
}

export function tenantCountry(branding) {
  const b = branding || {};
  const offered = Array.isArray(b.countries)
    ? b.countries.map(c => String(c).toUpperCase()).filter(c => TENANT_COUNTRIES.includes(c))
    : [];
  const preferred = b.default_country ? String(b.default_country).toUpperCase() : null;
  if (preferred && TENANT_COUNTRIES.includes(preferred) && (!offered.length || offered.includes(preferred))) {
    return preferred;
  }
  return offered[0] || 'NO';
}
